<template>
	<li class="card stack" @click="$router.push({ name: 'stack', params: { slug: stack.slug }})">
	<div class="stack-actions">
		<button type="button" v-on:click.stop="remove" v-if="user">delete</button>
		<button type="button" @click.stop="updateStackModal" v-if="user">edit</button>
	</div>
	<h2 class="stack-title"><router-link :to="{ name: 'stack', params: { slug: stack.slug }}">{{stack.title}}</router-link></h2>
	<p class="stack-why">{{stack.description}}</p>
	<div class="stack-meta">
		<p><span v-if="stack.cards">{{cardNumber(stack.cards)}}</span><span v-else>0</span> cards curated by {{stack.username}}</p>
	</div>
	
	</li>
</template>

<script>
import stackFunctions from '../../data/stackFunctions'
import cardRepository from '../../data/CardRepository'
import EventBus from '../EventBus'
export default {
	props: ['stack', 'user'],
	data() {
		return {
		}
	},
	components: {
	},
	methods: {
		cardNumber: function(cards){
			return Object.keys(cards).length;
		},
		remove() {
			if(this.stack.cards){
				var cardkeys = Object.keys(this.stack.cards)
				cardRepository.removeStackfromCards(this.stack, cardkeys, (err) => {
					if (err) throw err	
				})
			}
			
		    stackFunctions.remove(this.stack, (err) => {
				if (err) throw err	
			})
		},
		updateStackModal() {
		    EventBus.$emit('stack.selected', this.stack)
		},
	},
	mounted() {
	}
}
</script>


// WEBPACK FOOTER //
// Stack.vue?d7186e6e